import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Confirm, Header, Form, Image, Icon, input } from 'semantic-ui-react'
import { inlineStyle } from '../../styles/custom'
import PermissionsManager from '../PermissionsManager'
import MediaButton from '../MediaButton'

const ShopSocialNetworkForm = ({ obj, data, type, status, onChange, onSubmit, onDelete, onClick }) => {
  // Fix: For offices
  let name = data.name
  if (data && !data.name) {
    const arrTitle = data.details.map(detail => detail.title)
    if (arrTitle) {
      name = arrTitle[1]
    }
  }

  return (
    <Form>
      <Header as="h1">{status.isNew ? 'Nouveau r' : 'R'}éseau social de <Link name='socialNetwork' to={`/${type}/${data.id}/social-networks`}>{name}</Link> {obj.name !== '' ? ' : '+obj.name : null}</Header>
      <Form.Field>
        <label>Nom</label>
        <input placeholder="Nom du réseau social" id="name" value={obj.name} onChange={onChange} />
      </Form.Field>
      <Form.Field>
        <label>Url</label>
        <input placeholder="Adresse du réseau social" id="url" value={obj.url} onChange={onChange} />
      </Form.Field>
      <Form.Field>
        <label>Image</label>
        {obj.image && typeof obj.image === 'string' ? <Image src={obj.image} size='tiny' /> : null }
        <MediaButton handleClick={onClick}></MediaButton>
      </Form.Field>
      <Form.Field>
        {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
          <PermissionsManager hasPermissions={['create_social_network', 'update_social_network']}>
            <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
          </PermissionsManager>
        }
        {!status.isNew ? (
          <div>
            <PermissionsManager hasPermissions={['delete_social_network']}>
              <Button type='submit' color='red' floated='right' onClick={(event, data) => { onDelete(event, { confirm: true }) }}><Icon name="delete" /> Suppression</Button>
            </PermissionsManager>
          </div>
        ) : null}
      </Form.Field>
      <Confirm content='Êtes-vous sûr(e) de vouloir supprimer ce réseau social ? Cette action est définitive.' open={status.deletion.confirm} onCancel={(event, data) => { onDelete(event, { confirm: null }) }} onConfirm={(event, data) => { onDelete(event, { confirm: false }) }} style={inlineStyle.modal} />
    </Form>
  )
}

export default ShopSocialNetworkForm



// WEBPACK FOOTER //
// ./src/components/form/SocialNetwork.js